import * as React from 'react';
import { ValidationModal, ModalOutcome } from '../Modal/ValidationModal';
import './LoaderButton.css';

export interface Props {
    className: string;
    onClick: () => Promise<void>;
    style?: React.CSSProperties;
    children?: JSX.Element | string;
    confirmation?: boolean;
    modalTitle?: string;
    modalBody?: JSX.Element | string;
    disabled?: boolean;
    load?: boolean;
}

interface State {
    loading: boolean;
    modalOpened: boolean;
}

export class LoaderButton extends React.Component {
    props: Props;
    state: State;

    constructor(props: Props) {
        super(props);
        this.state = {
            loading: false,
            modalOpened: false,
        };
    }

    render() {
        var classe = this.props.className + (
            (this.state.loading || this.props.disabled === true || this.props.load === true) ?
            ' disabled' :
            ''
        );
        var content = (this.state.loading || this.props.load === true) ?
            <i className="fas fa-spinner fa-spin" /> :
            this.props.children;
        var modal: JSX.Element | undefined = undefined;
        if (this.props.confirmation === true && this.props.disabled !== true) {
            modal = (
                <ValidationModal
                    onClose={this.modalHandler}
                    title={this.props.modalTitle !== undefined ? this.props.modalTitle : 'Confirmation'}
                    show={this.state.modalOpened}
                >
                    <div>
                        {this.props.modalBody}
                    </div>
                </ValidationModal>
            );
        }
        return (
            <div>
                <button
                    className={classe}
                    onClick={
                        () => {
                            if (!this.state.loading && this.props.disabled !== true) {
                                this.setState({ loading: true, modalOpened: true });
                                if (this.props.confirmation !== true) {
                                    this.modalHandler(ModalOutcome.VALIDATE);
                                }
                            }
                        }
                    }
                    style={this.props.style}
                >
                    {content}
                </button>
                {modal}
            </div>
        );
    }

    private modalHandler = (o: ModalOutcome) => {
        this.setState({ modalOpened: false });
        if (o === ModalOutcome.VALIDATE) {
            this.props.onClick().then(
                () => {
                    this.setState({ loading: false });
                }
            ).catch(
                () => {
                    this.setState({ loading: false });
                }
            );
        } else {
            this.setState({ loading: false });
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/genericComponents/Button/LoaderButton.tsx